// Фильтр-полоса над списком: глоссарий (по набору терминов) и история
// изменений продукта (по годам).
//
// Почему не Razor-компонент: содержимое списков уже отрисовано сервером,
// фильтр только показывает и прячет готовые элементы. Компоненту пришлось бы
// владеть всем списком и перерисовывать его через SignalR — обращение к
// серверу на каждый щелчок и цепь Blazor на странице, которой она больше
// ни для чего не нужна. Здесь достаточно переключения атрибута.
//
// Разметка:
//   <div class="..." data-filter="ИМЯ">
//       <span data-filter-value="">Все</span>
//       <span data-filter-value="КОД">Название</span>
//   </div>
//   <div data-filter-target="ИМЯ" data-filter-value="КОД">...</div>
//
// В data-filter-value у элемента списка можно перечислить несколько значений
// через запятую — элемент покажется, если совпало любое.
//
// Пустое значение означает «показать всё». Если у полосы задан
// data-filter-default, при загрузке применяется он: так ведут себя
// взаимоисключающие разделы, где варианта «все» нет.

window.zs = window.zs || ({} as Zs);

window.zs.filters = {
    apply: function (name: string, value: string): void {
        document
            .querySelectorAll('[data-filter="' + name + '"] [data-filter-value]')
            .forEach(function (button) {
                const own = button.getAttribute("data-filter-value") || "";
                button.classList.toggle("selected", own === value);
            });

        document
            .querySelectorAll<HTMLElement>('[data-filter-target="' + name + '"]')
            .forEach(function (item) {
                const values = (item.getAttribute("data-filter-value") || "").split(",");
                item.hidden = value !== "" && values.indexOf(value) === -1;
            });
    },

    init: function (): void {
        document.querySelectorAll("[data-filter]").forEach(function (bar) {
            const name = bar.getAttribute("data-filter");

            if (name === null) {
                return;
            }

            const initial = bar.getAttribute("data-filter-default");

            if (initial !== null) {
                window.zs.filters.apply(name, initial);
            }

            bar.addEventListener("click", function (event) {
                const target = event.target;

                if (!(target instanceof Element)) {
                    return;
                }

                const button = target.closest("[data-filter-value]");

                if (!button || !bar.contains(button)) {
                    return;
                }

                window.zs.filters.apply(name, button.getAttribute("data-filter-value") || "");
            });
        });
    }
};

// --- Текстовый фильтр -------------------------------------------------------
// Поле быстрого поиска по готовому списку:
//   <input data-filter-search="ИМЯ">
//   <li data-filter-text="название в нижнем регистре" data-filter-item="ИМЯ">
//   <p data-filter-empty="ИМЯ" hidden>Ничего не найдено</p>

function initTextFilters(): void {
    document.querySelectorAll<HTMLInputElement>("[data-filter-search]").forEach(function (input) {
        const name = input.getAttribute("data-filter-search");

        input.addEventListener("input", function () {
            const needle = input.value.trim().toLowerCase();
            let shown = 0;

            document
                .querySelectorAll<HTMLElement>('[data-filter-item="' + name + '"]')
                .forEach(function (item) {
                    const text = item.getAttribute("data-filter-text") || "";
                    const match = needle === "" || text.indexOf(needle) !== -1;
                    item.hidden = !match;
                    shown += match ? 1 : 0;
                });

            const empty = document.querySelector<HTMLElement>('[data-filter-empty="' + name + '"]');
            if (empty) {
                empty.hidden = shown !== 0;
            }
        });
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTextFilters);
} else {
    initTextFilters();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", window.zs.filters.init);
} else {
    window.zs.filters.init();
}
